import { useState, useEffect, useCallback, useRef } from "react";
import { formatInputToCapitalization } from "../Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/actions/action-creator";

export const useInputActionGroup = ({ data, setData, validations, refs, check_dropdown, inputRefs }) => {
    const [submitConfirm, setSubmitConfirm] = useState('');
    const dispatch = useDispatch();
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (e.code === "Space" || e.key === "Enter") {
            e.preventDefault();
            return;
        }

        // Apply field-specific validations
        const validation = validations[name];
        if (validation) {
            const isValid = validation(value);
            if (isValid || value === "") {
                const updatedValue = (name === 'company_name' || name === 'mailing_name' || name === 'address' || name === 'city' || name === 'name' || name === 'ledger_name' || name === 'alise_name' || name === 'symbol' || name === 'formal_name')
                    ? formatInputToCapitalization(value)
                    : (name === 'no_of_decimal_place' || name === 'no_of_decimal_place_for_amount')
                        ? value.slice(-1)
                        : value;
                setData((prevData) => ({ ...prevData, [name]: updatedValue }));
            }
        } else {
            setData((prevData) => ({ ...prevData, [name]: value }));
        }
    };
    const handleDropdownClick = (name, value) => {
        let nextField = null;
        if (name === "under_id") {
            nextField = value === "Primary" ? "nature_of_group" : "group_behaves_like_sub_ledger";
        } else {
            const fields = Object.keys(inputRefs);
            const currentIndex = fields.indexOf(name);

            // Find next available field by checking if current exists and is not the current name
            for (let i = currentIndex + 1; i < fields.length; i++) {
                const fieldName = fields[i];
                if (inputRefs[fieldName]?.current && !inputRefs[fieldName].current.disabled) {
                    nextField = fieldName;
                    break;
                }
            }
        }

        if (nextField && inputRefs[nextField]?.current) {
            setTimeout(() => {
                if (inputRefs[nextField]?.current) {
                    inputRefs[nextField].current.focus();
                    inputRefs[nextField].current.setSelectionRange(0, inputRefs[nextField].current.value.length);
                }
            }, 0);
        } else {
            setSubmitConfirm('Accept')
            inputRefs[name]?.current?.blur();
        }
    }

    const handleFocus = (e) => {
        const { name } = e.target;
        const focusAction = refs[name]?.onFocus;
        if (name === 'used_for_calculation') {
            setSubmitConfirm("");
        }
        if (focusAction) focusAction();
    };

    const handleBlur = (e) => {
        if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) return;
        const { name, value } = e.target;
        const blurAction = refs[name]?.onBlur;
        if (blurAction) blurAction(value, setData);
    };

    const handleKeyDown = (e) => {
        if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) {
            return;
        }
        const { name, value } = e.target;
        if (e.key === "Enter" || (e.key === 'Tab' && !e.shiftKey)) {
            e.preventDefault();
            e.stopPropagation();
            handleDropdownClick(name, value);
            return;
        }

        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            e.stopPropagation();
            let nextField = null;

            // Handle special case for under_id field in reverse
            if (name === "group_behaves_like_sub_ledger" || name === "nature_of_group") {
                nextField = "under_id";
            } else {
                // Default sequential navigation
                const fields = Object.keys(inputRefs);
                const currentIndex = fields.indexOf(name);

                // Find previous available field
                for (let i = currentIndex - 1; i >= 0; i--) {
                    const fieldName = fields[i];
                    if (inputRefs[fieldName]?.current && !inputRefs[fieldName].current.disabled) {
                        nextField = fieldName;
                        break;
                    }
                }
            }

            if (nextField && inputRefs[nextField]?.current) {
                inputRefs[nextField].current.focus();
                inputRefs[nextField].current.setSelectionRange(0, inputRefs[nextField].current.value.length);
            } else {
                inputRefs[name]?.current?.focus();
            }
            return;
        }
    }



    return {
        data,
        setData,
        handleChange,
        handleFocus,
        handleBlur,
        handleKeyDown,
        submitConfirm,
        setSubmitConfirm,
        handleDropdownClick
    };
};
